import { useTranslation } from 'react-i18next';
import { Text } from '@connect-x-app/hybrid-ui';
import { COLORS } from '@connect-x-app/shared-ui';
import { CHANNEL_TEST_IDS } from '@connect-x-app/web-test-ids';
import { EmptyState } from '@connect-x-app/web-ui';

export const ChannelSelectionEmpty = () => {
  const { t } = useTranslation();

  return (
    <EmptyState icon="arrowLeft" testId={CHANNEL_TEST_IDS.empty.selection}>
      <Text className="empty-body-text" color={COLORS.zulu.$08} size="SM">
        {t('CHAT.CHANNELS.SELECT_CHANNEL')}
      </Text>
    </EmptyState>
  );
};
